<template>
  <div id="page-loading">
    <div id="loading-bg">
      <div class="loading">
        <div class="effect-1 effects" />
        <div class="effect-2 effects" />
        <div class="effect-3 effects" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
